import { Currency } from '@/core/currency/interfaces';

const AFN: Currency = {
    name: 'Afghan Afghani',
    demonym: 'Afghan',
    majorSingle: 'Afghani',
    majorPlural: 'Afghani',
    codeNumeric: '971',
    symbol: 'Af',
    symbolNative: '؋',
    minorSingle: 'Pul',
    minorPlural: 'Pul',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'AFN',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default AFN;
